module.exports = __webpack_public_path__ + "images/045546483711bc7ef0fb15aee7301c29.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/ayse.jpg
// module id = 161
// module chunks = 24